import { reactive, toRefs } from '@vue/composition-api';

export function usePractice(token: string) {
  const { ServiceFactory } = require('@/service/ServiceFactory');
  const instance = ServiceFactory.get('practice');

  const practiceState = reactive({
    practiceList: [],
  });

  /**
   * Fetch practice list from api
   * */
  async function fetchPractice() {
    try {
      practiceState.practiceList = await instance.list(token);
    } catch (e) {
      throw e;
    }
  }

  return {
    ...toRefs(practiceState),
    fetchPractice,
  };
}
